import React, { useState } from "react";
import toast from "react-hot-toast";
import { server } from "../server";

const CarRentalModal = ({ isOpen, closeModal }) => {
  const [formData, setFormData] = useState({
    carType: "",
    chauffeur: "",
    startDate: "",
    endDate: "",
    contactMethod: "",
    numberOfDays: 0,
    carModel: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleDateChange = () => {
    const { startDate, endDate } = formData;
    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      const timeDifference = end.getTime() - start.getTime();
      const daysDifference = timeDifference / (1000 * 3600 * 24);
      setFormData({ ...formData, numberOfDays: daysDifference + 1 });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !formData.carType ||
      !formData.chauffeur ||
      !formData.startDate ||
      !formData.endDate ||
      !formData.contactMethod ||
      !formData.carModel
    ) {
      toast.error("Please fill in all fields before submitting.");
      return;
    }

    const toasId = toast.loading("Submitting reservation...");

    try {
      // Send email with reservation details
      const response = await fetch(`${server}/send-email`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: "dadyjohn2004@gmail.com",
          subject: `Car Rental Reservation from ${formData.contactMethod}`,
          message: `
            <html>
              <body style="font-family: Arial, sans-serif; background-color: #f4f4f4; padding: 20px; color: #333;">
                <div style="background-color: #fff; padding: 20px; border-radius: 8px;">
                  <h2 style="text-align: center; color: #e59400;">Greatings From Website</h2>
                  <h2 style="text-align: center; color: #e59400;">New Car Rental Reservation</h2>
                  <p><strong>Car Type:</strong> ${formData.carType}</p>
                  <p><strong>Car Model:</strong> ${formData.carModel}</p>
                  <p><strong>Chauffeur Required:</strong> ${formData.chauffeur}</p>
                  <p><strong>Rental Dates:</strong> ${formData.startDate} to ${formData.endDate}</p>
                  <p><strong>Number of Days:</strong> ${formData.numberOfDays}</p>
                  <p><strong>Contact Method:</strong> ${formData.contactMethod}</p>
                  <div style="text-align: center; margin-top: 30px;">
                    <p style="font-size: 14px; color: #888;">Thank you for choosing our car rental service. We will get back to you shortly.</p>
                  </div>
                </div>
              </body>
            </html>
          `,
        }),
      });

      if (response.ok) {
        toast.dismiss(toasId);
        toast.success(
          "Your reservation has been submitted. We will contact you Soon.☺️",
          { duration: 10000 }
        );
        closeModal();
        setFormData({
          carType: "",
          chauffeur: "",
          startDate: "",
          endDate: "",
          contactMethod: "",
          numberOfDays: 0,
          carModel: "",
        });
      } else {
        toast.dismiss(toasId);
        toast.error(
          "Sorry, there was an issue submitting your reservation. Please try again.☺️"
        );
      }
    } catch (error) {
      toast.dismiss(toasId);
      console.error("Error sending email:", error);
      toast.error(
        "Sorry, there was an issue submitting your reservation. Please try again."
      );
    }
  };

  const getCarModels = () => {
    if (formData.carType === "SUV 4x4") {
      return (
        <>
          <option value="">Select 4x4 SUV </option>
          <option value="Mazda CX-5">Mazda CX-5</option>
          <option value="Nissan X-Trail">Nissan X-Trail</option>
          <option value="Toyota Vanguard">Toyota Vanguard</option>
          <option value="Toyota Prado TX">Toyota Prado TX</option>
        </>
      );
    } else if (formData.carType === "Saloon") {
      return (
        <>
          <option value="">Select Saloon</option>
          <option value="Toyota Fielder">Toyota Fielder</option>
          <option value="Toyota Axio">Toyota Axio</option>
        </>
      );
    }
    return <option value="">Select Car Type First</option>;
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 1000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(255, 255, 255, 0.1)",
        backdropFilter: "blur(5px)",
      }}
      onClick={closeModal}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "30px",
          maxWidth: "600px",
          width: "100%",
          borderRadius: "8px",
          position: "relative",
          maxHeight: "90%",
          overflowY: "auto",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={closeModal}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            backgroundColor: "transparent",
            border: "none",
            fontSize: "24px",
            cursor: "pointer",
          }}
        >
          &times;
        </button>

        <h1
          style={{
            textAlign: "center",
            color: "#333",
            marginBottom: "10px",
          }}
        >
          Reserve a Car
        </h1>

        <form
          onSubmit={handleSubmit}
          style={{ maxWidth: "800px", margin: "0 auto", textAlign: "start" }}
        >
          <div style={{ marginBottom: "20px" }}>
            <label
              htmlFor="carType"
              style={{
                display: "block",
                fontSize: "16px",
                marginBottom: "8px",
                color: "gray",
              }}
            >
              Car Type
            </label>
            <select
              id="carType"
              name="carType"
              value={formData.carType}
              onChange={handleInputChange}
              required
              style={{
                width: "100%",
                padding: "10px",
                fontSize: "16px",
                border: "1px solid #ccc",
                borderRadius: "5px",
              }}
            >
              <option value="">Select Car Type</option>
              <option value="Saloon">Saloon</option>
              <option value="SUV 4x4">SUV 4x4</option>
            </select>
          </div>

          <div style={{ marginBottom: "5px" }}>
            <label
              htmlFor="carModel"
              style={{
                display: "block",
                fontSize: "16px",
                marginBottom: "8px",
                color: "gray",
              }}
            >
              Car Model
            </label>
            <select
              id="carModel"
              name="carModel"
              value={formData.carModel}
              onChange={handleInputChange}
              required={formData.carType !== ""}
              style={{
                width: "100%",
                padding: "10px",
                fontSize: "16px",
                border: "1px solid #ccc",
                borderRadius: "5px",
              }}
              disabled={formData.carType === ""}
            >
              {getCarModels()}
            </select>
          </div>

          <div style={{ marginBottom: "5px" }}>
            <label
              htmlFor="chauffeur"
              style={{
                fontSize: "16px",
                marginBottom: "8px",
                color: "gray",
              }}
            >
              Do you need a Driver?
            </label>
            <select
              id="chauffeur"
              name="chauffeur"
              value={formData.chauffeur}
              onChange={handleInputChange}
              style={{
                width: "100%",
                padding: "10px",
                fontSize: "16px",
                border: "1px solid #ccc",
                borderRadius: "5px",
              }}
            >
              <option value="">Select Chauffeur Option</option>
              <option value="Chauffeur">Chauffeur needed</option>
              <option value="Self-Driven">Self-Driven</option>
            </select>
          </div>

          <div style={{ marginBottom: "5px" }}>
            <label
              htmlFor="startDate"
              style={{
                display: "block",
                fontSize: "16px",
                marginBottom: "8px",
                color: "gray",
              }}
            >
              Rental Dates (From - To)
            </label>
            <div style={{ display: "flex", gap: "10px" }}>
              <input
                type="date"
                id="startDate"
                name="startDate"
                value={formData.startDate}
                onChange={handleInputChange}
                required
                style={{
                  width: "48%",
                  padding: "10px",
                  fontSize: "16px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                }}
              />
              <input
                type="date"
                id="endDate"
                name="endDate"
                value={formData.endDate}
                onChange={handleInputChange}
                required
                style={{
                  width: "48%",
                  padding: "10px",
                  fontSize: "16px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                }}
                onBlur={handleDateChange}
              />
            </div>
            {formData.numberOfDays > 0 && (
              <p
                style={{
                  marginTop: "10px",
                  fontSize: "16px",
                  color: "#e59400",
                }}
              >
                Book for {formData.numberOfDays} days
              </p>
            )}
          </div>

          <div style={{ marginBottom: "5px" }}>
            <label
              htmlFor="contactMethod"
              style={{
                display: "block",
                fontSize: "16px",
                marginBottom: "8px",
                color: "gray",
              }}
            >
              Phone or WhatsApp Number or Email (for reply)
            </label>
            <input
              type="text"
              id="contactMethod"
              name="contactMethod"
              value={formData.contactMethod}
              onChange={handleInputChange}
              style={{
                width: "100%",
                padding: "10px",
                fontSize: "16px",
                border: "1px solid #ccc",
                borderRadius: "5px",
              }}
            />
          </div>
          <button
            type="submit"
            style={{
              backgroundColor: "#e59400",
              color: "#fff",
              padding: "12px 25px",
              fontSize: "16px",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              width: "100%",
            }}
          >
            Submit Reservation
          </button>
        </form>
      </div>
    </div>
  );
};

export default CarRentalModal;
